<template>
    <div class="row">
        <b-col col lg="9" md="9" >
            <b-row class="match-height">
                <b-col col lg="5" md="5" sm="12">
                    <subscription-plan/>
                </b-col>
                <b-col col lg="7" md="7" sm="12">
                    <subscription-invoice/>
                </b-col>
            </b-row>
        </b-col>
        <b-col col lg="3" md="3" sm="12" >
            <creditfixrr-coupon/>
        </b-col>
    </div>
</template>
<script>
import {
  BRow, BCol,
} from 'bootstrap-vue-3'
import CreditfixrrCoupon from './CreditfixrrCoupon.vue'
import SubscriptionInvoice from './SubscriptionInvoice.vue'
import SubscriptionPlan from './SubscriptionPlan.vue'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { usePlanStore } from '../../stores/PlanStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'
import { useUserStore } from '../../stores/UserStore.js'

export default{
    components:{
        CreditfixrrCoupon,
        SubscriptionInvoice,
        SubscriptionPlan,
    },
    setup(props) {
        return{
            localizationStore: useLocalizationStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            userStore: useUserStore(),
        }
    },
}
</script>
